// Deterministic value in [0, 1) for a key (FNV-1a). Same key -> same value.
export const hashUnit = (key: string): number => {
  let hash = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) / 4294967296;
};

const isShortStay = (name: string): boolean =>
  name.toLowerCase().replace(/[^a-z]/g, '').includes('shortstay');

/**
 * The clinical template auto-selected for a patient (demo: as if chosen from
 * recent chart activity). Deterministic per patient and never picks "Short Stay".
 * Returns undefined when there are no eligible templates.
 */
export const pickDefaultTemplate = <T extends { id: number; name: string }>(
  templates: T[],
  patientId: string,
): T | undefined => {
  const candidates = templates.filter((t) => !isShortStay(t.name));
  if (!candidates.length) {
    return undefined;
  }
  return candidates[Math.floor(hashUnit(`${patientId}:default-template`) * candidates.length)];
};
